import Item from 'common/ITEMS/Item';

const items = {
  //region Brewmaster
  //endregion
  //region Mistweaver
  //endregion
  //region Windwalker
  //endregion
  //region Shared
  //endregion
} satisfies Record<string, Item>;
export default items;
